
import {UIGameSpecialBuildPhaseButtonController} from '../../../../shared/scripts/ui_game/ui_game_special_build_phase/UIGameSpecialBuildPhaseButtonController'
import {SpriteButtonView} from '../../../../shared/scripts/ui_canvas_engine/SpriteButtonView'
import {GameStateEnums} from '../../../../../shared/GameEnums'
import UIGameEventEnums = GameStateEnums.UIGameEventEnums
import {UIMGameManager} from '../UIMGameManager'
import {SectionBgView} from '../../../../shared/scripts/ui_canvas_engine/SectionBgView'
import {MechanicSpecialBuildPhaseState} from '@colonist/game-states'

export class UIMGameSpecialBuildPhaseButtonController extends UIGameSpecialBuildPhaseButtonController {
    private container?: SectionBgView

    constructor(uiGameManager: UIMGameManager, specialBuildPhaseState: MechanicSpecialBuildPhaseState) {
        super(uiGameManager, specialBuildPhaseState)
        if(this.container) {
            uiGameManager.animationController.registerForFeedMechanics(this.container)
        }
        this.onTurnUpdate()
    }

    protected createButton() {
        const canvas = this.uiGameManager.canvasController
        const w = canvas.itemSize
        const h = canvas.itemSize
        const padding = canvas.itemSize / 8
        const x = canvas.appW - padding - w
        const y = canvas.appH - canvas.bottomViewHeight - h - padding
        this.container = new SectionBgView(x, y, w, h, canvas.app.stage)
        this.button = new SpriteButtonView(0, 0, w, h, this.container)
        super.createButton()
    }

    onEvent(data: any, eventType: UIGameEventEnums) {
        super.onEvent(data, eventType)
        switch(eventType) {
            case UIGameEventEnums.GameStateUpdated: this.onTurnUpdate(); break
            default: break
        }
    }

    private onTurnUpdate() {
        if(this.button === undefined) return

        const shouldShowSpecialBuildPhase = this.uiGameManager.gameController.isMyTurn ? false : true
        this.button.visible = shouldShowSpecialBuildPhase
    }
}
